module.exports = __webpack_public_path__ + "assets/pluspos.179dcb39.svg";